import api from './index.js'
import multipart_api from './multipart_index.js'

export default {

  getStatus(nfc_uid) {
    return api.get(`devices/get_status/${nfc_uid}`);
  },

  playSound(nfc_uid, sound_id, volume) {
    if(volume < 0) {
      volume = 0
    } else if(100 < volume) {
      volume = 100;
    }
    volume /= 50;
    const params = {
      sound_id: sound_id,
      volume: volume
    };
    return api.post(`devices/play_sound/${nfc_uid}`, params);
  },

  setTouchSound(nfc_uid, sound_id, volume) {
    if(volume < 0) {
      volume = 0
    } else if(100 < volume) {
      volume = 100;
    }
    volume /= 50;
    const params = {
      sound_id: sound_id,
      volume: volume
    };
    return api.post(`devices/set_touch_sound/${nfc_uid}`, params);
  },

  getNfcData(nfc_uid) {
    return api.get(`devices/get_nfc/${nfc_uid}`);
  },

  startOta(nfc_uid, url, version) {
    const params = {
      url: url,
      version: version
    };
    return api.post(`devices/start_ota/${nfc_uid}`, params);
  },

  updateAudio(nfc_uid, audio_file, sound_id) {
    const formData = new FormData();
    formData.append('audio_file', audio_file);
    formData.append('sound_id', sound_id);
    return multipart_api.post(`devices/update_audio/${nfc_uid}`, formData);
  },

  initNfc(nfc_uid) {
    return api.post(`devices/init_nfc/${nfc_uid}`);
  },

  updateNfc(nfc_uid) {
    return api.post(`devices/update_nfc/${nfc_uid}`);
  },

  updateNfcAll() {
    return api.post('devices/update_nfc_all');
  },
}
